import { useContext } from 'react';
import { AlertContext } from '../contexts/alertContext';

export const useAlert = () => {
    const context = useContext(AlertContext);

    if (context === null) {
        throw new Error('useAlert must be used within an AlertProvider');
    }

    return context;
};